import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, AlertController } from 'ionic-angular';

import { OperadorInfopedidoPage } from '../operador-infopedido/operador-infopedido';
import { OperadorOperacaoPage } from '../operador-operacao/operador-operacao';
import { OperadorCaixasPage } from '../operador-caixas/operador-caixas';
import { WelcomePage } from '../welcome/welcome';

import { AdiantadorOperacaoPage } from '../adiantador-operacao/adiantador-operacao';

import { Services, Tools, User, Api } from '../../providers';

@IonicPage()
@Component({
  selector: 'page-adiantador-pedidos',
  templateUrl: 'adiantador-pedidos.html',
})
export class AdiantadorPedidosPage {
  separacao:any={_id:false};
  pedidos:any=[];
  pedidosorig:any=[];
  url:any = 'http://barbosa.ibrs.com.br:5000/api/tracking/listarsep';
  urlProdutos:any = 'http://barbosa.ibrs.com.br:5000/api/tracking/buscarprodutosimg';

  separacaoLS:any={};
  postObj:any={};
  carrinho:any={
    pedidosId:[],
    pedidos:0,
    produtos:0
  }

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public alertCtrl: AlertController,
    private api: Api,
    private user: User,
    private services: Services,
    private tools: Tools
  ) {
  }

  ionViewDidLoad() {
    this.loadList();
  }

  sendPost(url,callback){
    var self = this;
    this.api.sendPost(url,self.postObj,{},function(result){
      callback(result);
    });
  }

  buscarProdutos(codigosBarra){
    var loading = this.tools.showLoading('Carregando');
    loading.present();

    let self = this;
    var urlBuscarProdutos = 'http://barbosa.ibrs.com.br:5000/api/tracking/buscarprodutosimg';
    console.log('Aqui');

    this.postObj = {codigos:codigosBarra};

    this.sendPost(urlBuscarProdutos,(result)=>{
      console.log(result);

      if(result.status && result.data && result.data.length>0){

        //Vincular Categoria NOVO
        this.pedidos.forEach(pedido => {
          pedido.items.forEach(produto => {
            produto.categoria = result.produtos.find(e => e.sku == produto.codigoBarra).categoria;
            produto.categoriaSecundaria = result.produtos.find(e => e.sku == produto.codigoBarra).categoriaSecundaria;
            produto.departamento = result.produtos.find(e => e.sku == produto.codigoBarra).departamento;

            var img = result.data.find(e=>e.linkId == produto.codigoBarra) || false;
            produto.img = img ? `http://barbosa.ibrs.com.br:4032/gridfs/${this.user.getSession()}/download/fileProdutos/${img.linkId}/-1` : null;
          });
        });

        //Filtrar Produtos Açougue
        var categoriasAcougue = ['BOVINOS', 'AVES', 'SUINOS'];
        var pedidos = [];

        this.pedidos.map(e=>{
          e.items = e.items.filter(f => categoriasAcougue.indexOf(f.categoria) >= 0);
          if(e.items.length>0){
            pedidos.push(e);
          }
          return e;
        });

        this.pedidos = pedidos;

        setTimeout(() => {
          loading.dismiss();
        }, 500);

      }else{
        self.tools.showAlert('toast',`${result.msg}`,1500);
        loading.dismiss();
      }
    });
  }

  loadList2(){

    let loading = this.tools.showLoading('Carregando...');
    loading.present();
    let self = this;

    var postObj = {
      "app_key":"rtEVWH9FSjx6KoUxMxuN0uC6",
      "app_secret":"4rEyQRcvb0P4",
      "lojaId":this.user.getUser().lojaId+''
    }

    this.api.sendPost(this.url,postObj,{},(result)=>{
      if(result.status){
        console.log('cadSeparacoes: ',result);

        let newdata = result.data.map(e=>{
          e.filter = e.codigo+' - '+e.operador;
          e.inicioText = new Date(e.inicio).toLocaleString('pt-BR').slice(11,16) || 'N/A';
          return e;
        });

        self.pedidosorig = newdata.concat([]);
        self.pedidos = newdata.concat([]);

        loading.dismiss();
      }else{
        // self.tools.storage('load','separacao',null,(e)=>{
        //   console.log(e);
        //
        //   if(e.status){
        //     self.separacao = JSON.parse(e.data);
        //
        //     self.carrinho.pedidosId = self.separacao.pedidosId;
        //     self.carrinho.pedidos = self.separacao.totalPedidos;
        //     self.carrinho.produtos = self.separacao.totalProdutos;
        //     self.carrinho._id = self.separacao._id;
        //     self.tools.showAlert('toast','Sem Internet, Pedido Encontrado LocalStorage');
        //   }else{
        //     self.tools.showAlert('toast','Sem Internet, Nenhum Pedido Encontrado');
        //   }
        //   loading.dismiss();
        // });
        self.tools.showAlert('toast','Sem Internet, Nenhum Pedido Encontrado');
      }

    });
  }

  loadList(){

    let loading = this.navParams.get('item');
    let self = this;

    var postObj = {
      "app_key":"rtEVWH9FSjx6KoUxMxuN0uC6",
      "app_secret":"4rEyQRcvb0P4",
      "lojaId":this.user.getUser().lojaId+''
    }

    this.api.sendPost(this.url,postObj,{},(result)=>{
      if(result.status){
        console.log('cadSeparacoes: ',result);

        let newdata = result.data.map(e=>{
          e.filter = e.codigo+' - '+e.operador;
          e.inicioText = new Date(e.inicio).toLocaleString('pt-BR').slice(11,16) || 'N/A';
          return e;
        });

        self.pedidosorig = newdata.concat([]);
        self.pedidos = newdata.concat([]);
        var codigos = self.pedidos.map(e=>e.items.map(f => f.codigoBarra)).flat();

        console.log(codigos);
        var codigosLimpos = codigos.filter((item, pos) => { return codigos.indexOf(item) == pos; });

        self.buscarProdutos(codigosLimpos);

        loading.dismiss();
      }else{
        // self.tools.storage('load','separacao',null,(e)=>{
        //   console.log(e);
        //
        //   if(e.status){
        //     self.separacao = JSON.parse(e.data);
        //
        //     self.carrinho.pedidosId = self.separacao.pedidosId;
        //     self.carrinho.pedidos = self.separacao.totalPedidos;
        //     self.carrinho.produtos = self.separacao.totalProdutos;
        //     self.carrinho._id = self.separacao._id;
        //     self.tools.showAlert('toast','Sem Internet, Pedido Encontrado LocalStorage');
        //   }else{
        //     self.tools.showAlert('toast','Sem Internet, Nenhum Pedido Encontrado');
        //   }
        //   loading.dismiss();
        // });
        self.tools.showAlert('toast','Sem Internet, Nenhum Pedido Encontrado');
        loading.dismiss();
      }

    });
  }

  addCarrinho(pedido){
    this.carrinho.pedidosId[0] = pedido._id+'';
    this.navCtrl.push(AdiantadorOperacaoPage,{item:this.pedidos.find(e=>this.carrinho.pedidosId.indexOf(e._id)>=0)});
  }

  getItems(event){
    if(event.target.value=='' || !event.target.value){this.pedidos=this.pedidosorig}
    else{
      this.pedidos = this.pedidosorig.filter(item=>{
        return (item.filter).toLowerCase().indexOf(event.target.value.toLowerCase()) > -1;
      });
    }
  }

  logout(){
    let confirm = this.alertCtrl.create({
      title: 'Confirmação',
      message: 'Deseja realmete sair ?',
      buttons: [
        { text: 'Não', handler: () => {} },
        { text: 'Sim', handler: () => { this.navCtrl.setRoot(WelcomePage); } }
      ]
    });
    confirm.present();
  }

}



// WEBPACK FOOTER //
// ./src/pages/adiantador-pedidos/adiantador-pedidos.ts